import { skipToken, useQuery } from "@tanstack/react-query"
import { requestIntensity } from "@/shared/utils/axios.ts"

export const CONTRACT_API_URL = `/contracts/audit-request/`

export interface IAuditContract {
  id: number
  company: {
    id: number
    name: string
    address: string | null
    inn: string
    region: {
      id: number
      name: string
    }
  }
  tz_file?: string
  contract_file?: string
  ready_to_upload_report: boolean
  need_to_start_audit_process: boolean
  deleted: string | null
  deleted_by_cascade: boolean
  created_at: string
  updated_at: string
  company_id: number
  auditor_id: number
  auditor_company_id: number
  contract_number: string
  deadline: string
  status: string
  status_changed_at: string | null
  step: number
  energy_audit: number
  audit_request: number
  application: number
}

export async function fetchContractByRequestId(requestId?: string) {
  const { data } = await requestIntensity.get(`${CONTRACT_API_URL}${requestId}/`)
  return data as IAuditContract
}

export const useFetchContractByRequestId = (requestId?: string | null) => {
  return useQuery({
    queryKey: ["contracts", requestId],
    queryFn: !requestId ? skipToken : () => fetchContractByRequestId(requestId)
  })
}
